/* eslint-disable import/prefer-default-export */
import * as types from '../action.types';

export const updateSearchTerm = term => ({
  type: types.UPDATE_SEARCH_TERM,
  payload: term,
});

export const resetState = () => ({
  type: types.RESET_STATE,
});
